import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";
// import {v4 as uuidv4} from 'uuid';
import UtilService from '../../../helper/service';

const initialState = {
  experience: null,
  single: null,
  reeladd: null,
  is_loaded: false,
  is_loading: false,
  is_search_loading: false,
  sessions: [],
  projectSessions: [],
  stimulus: [],
  searchKey: <any>null,
  searchText: '',
  searchUsers: [],
  showMergeButton: true,

  searchfilters:'',
  creatorList:[],
  participants: null,
  listLoading: true,
  totalExperience: 0,
  totalExperienceCount: null,
  reels_page:1,
  page: 1,
  searchClipPage: 1,
  searchSessionPage: 1,
  reels: [],
  totalReelExperience: null,
  totalSearchExperience: null,
  totalSearchClip: null,
  reel_sessions: null,
  onlyReelSessions: [],
  ownerSessionCount: 0,
  //Dashboard
  sort_column_value:'',
  sort_direction :'',
  filter_name:'',
  filter_direction:false,
  //project
  sort_column_value_project:'',
  sort_direction_project :'',
  filter_name_project:'',
  filter_direction_project:false,
  // reels
  reels_filter_direction: false,
  reels_filter : '',
  reels_sort_column :'', 
  reels_sort_direction:'',
  benchmarkLoading: false,
  searchCleared: false,
  searchnewText: '',
  checked: [],
  selected: [],
  isUserDropdown: false
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
      
    case actionTypes.EXPERIENCE_GET_LIST_SUCCESS:

      const { items } = action.payload;
      let addExperience: any = items.firstpage ? [] : [...state.sessions];
      //filter deleted Expetience from list
      if(!!localStorage.getItem("deleteExpId")){
        const delId = Number(localStorage.getItem("deleteExpId")) 
        addExperience = addExperience.filter((x:any) => x.session_id !== delId);
        localStorage.removeItem("deleteExpId");
      }
      items.sessions && items.sessions.length && items.sessions.map((item: any) => {
        const clips = []
        const totalClips = item.stimulus_clips ? item.stimulus_clips : []
        for (let i = 0; i < totalClips.length; i++) {

          const mod_length = UtilService.convertSecondsToHHMMSS(Number(totalClips[i].end_clip) - Number(totalClips[i].start_clip));
          const mod_start = Number(totalClips[i].start_clip);
          const mod_end = Number(totalClips[i].end_clip);

          const async_length = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip) - UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip));

          clips.push({
            // session_id: 'clip-' + uuidv4(),
            session_id: 'clip-' + totalClips[i].clip_id,
            session_code: item.session_code,
            session_type: item.session_type,
            session_title: item.session_title,
            session_status: item.session_status,
            img: '/assets/images/video-processing.png',
            name: totalClips[i].title ? totalClips[i].title : '-',
            immersion: totalClips[i].immersion_index ? Number(totalClips[i].immersion_index) : '-',
            safety: totalClips[i].safety_index ? Number(totalClips[i].safety_index) : '-',
            length: item.session_type === 'ASYNC' ? async_length : mod_length,
            start: item.session_type === 'ASYNC' ? async_start : mod_start,
            end: item.session_type === 'ASYNC' ? async_end : mod_end,
            safety_tier_indicator: totalClips[i].safety_tier_indicator,
            safety_color_indicator: totalClips[i].safety_color_indicator,
            safety_context_indicator: totalClips[i].safety_context_indicator,
            immersion_color_indicator: totalClips[i].immersion_color_indicator,
            immersion_context_indicator: totalClips[i].immersion_context_indicator,
            immersion_tier_indicator: totalClips[i].immersion_tier_indicator,
            clip_id: totalClips[i].clip_id
          })
        }

        const immersionDetail: any = {
          'Captivated': 0,
          'Absorbed': 0,
          'Interested': 0,
          'Indifferent': 0,
          'Tuned Out': 0
        };

        const immersionBreakup: [] = item.immersion_breakup ? item.immersion_breakup : [];
        for (let i = 0; i < immersionBreakup.length; i++) {
          const item: any = immersionBreakup[i];
          immersionDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const safetyDetail: any = {
          'Zen': 0,
          'Very Safe': 0,
          'Safe': 0,
          'Unsafe': 0,
          'Very Unsafe': 0
        };

        const safetyBreakup: [] = item.safety_breakup ? item.safety_breakup : [];
        for (let i = 0; i < safetyBreakup.length; i++) {
          const item: any = safetyBreakup[i];
          safetyDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const objectData: any = {
          session_id: item.session_id,
          project_id: item.project_id,
          braintrust_id: item.braintrust_id,
          participants: item.participantscount,
          name: item.session_title,
          immersion: Number(item.immersion_index),
          safety: Number(item.safety_index),
          immersion_color_indicator: item.immersion_color_indicator,
          safety_color_indicator: item.safety_color_indicator,
          start: item.started_at ? item.started_at : item.scheduled_start_at,
          end: item.ended_at ? item.ended_at : item.scheduled_end_at,
          status: item.session_status,
          session_code: item.session_code,
          session_category: item.session_category,
          session_subcategory: item.session_subcategory,
          clips: clips,
          immersion_detail: immersionDetail,
          safety_detail: safetyDetail,
          img: item.small_thumbnail ? item.small_thumbnail : '/assets/images/video-processing.png',
          img_large: item.large_thumbnail ? item.large_thumbnail : '/assets/images/video-processing.png',
          stimulus_type: item.stimulus_type,
          stimulus_status: item.stimulus_status,
          project_folders: item.project_folders,
          user: item.user,
          userColor:"hsl(" + Math.random() * 360 + ", 100%, 75%)",
          session_trim_from: item.session_trim_from,
          session_type: item.session_type,
          session_length: item.session_length,
          survey_link: item.survey_link,
          saved_benchmark: item.saved_benchmark,
          show_banner: item.show_banner
        };
        
        if (!addExperience.find((val: any) => val.session_id === item.session_id)) {
          addExperience.push(objectData)
        } else {
          let index: any = ''
          for (let j = 0; j < addExperience.length; j++) {
            if (addExperience[j].session_id === item.session_id) {
              index = j
            }
          }
          if (index !== '') {
            addExperience[index] = objectData
          }
        }
        return objectData
      })

      return updateObject(state, {
        sessions: addExperience,
        experience: items,
        is_loaded: true,
        listLoading: false,
        totalExperience: items.count ? items.count : 0,
        userColumn : items.show_user_column,
        ownerSessionCount : items.ownerSessionCount,
      });

    case actionTypes.CHECK_STIMULUS_STATUS_SUCCESS:

      const { stimulusitem } = action.payload;
      
      const newItems : any = state.sessions;

      stimulusitem && stimulusitem.length && stimulusitem.map((item: any) => {
        const clips = []
        const totalClips = item.stimulus_clips ? item.stimulus_clips : []
        for (let i = 0; i < totalClips.length; i++) {

          const mod_length = UtilService.convertSecondsToHHMMSS(Number(totalClips[i].end_clip) - Number(totalClips[i].start_clip));
          const mod_start = Number(totalClips[i].start_clip);
          const mod_end = Number(totalClips[i].end_clip);

          const async_length = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip) - UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip));

          clips.push({
            // session_id: 'clip-' + uuidv4(),
            session_id: 'clip-' + totalClips[i].clip_id,
            session_code: item.session_code,
            session_type: item.session_type,
            session_title: item.session_title,
            session_status: item.session_status,
            img: '/assets/images/video-processing.png',
            name: totalClips[i].title ? totalClips[i].title : '-',
            immersion: totalClips[i].immersion_index ? Number(totalClips[i].immersion_index) : '-',
            safety: totalClips[i].safety_index ? Number(totalClips[i].safety_index) : '-',
            length: item.session_type === 'ASYNC' ? async_length : mod_length,
            start: item.session_type === 'ASYNC' ? async_start : mod_start,
            end: item.session_type === 'ASYNC' ? async_end : mod_end,
            safety_tier_indicator: totalClips[i].safety_tier_indicator,
            safety_color_indicator: totalClips[i].safety_color_indicator,
            safety_context_indicator: totalClips[i].safety_context_indicator,
            immersion_color_indicator: totalClips[i].immersion_color_indicator,
            immersion_context_indicator: totalClips[i].immersion_context_indicator,
            immersion_tier_indicator: totalClips[i].immersion_tier_indicator,
            clip_id: totalClips[i].clip_id
          })
        }

        const immersionDetail: any = {
          'Captivated': 0,
          'Absorbed': 0,
          'Interested': 0,
          'Indifferent': 0,
          'Tuned Out': 0
        };

        const immersionBreakup: [] = item.immersion_breakup ? item.immersion_breakup : [];
        for (let i = 0; i < immersionBreakup.length; i++) {
          const item: any = immersionBreakup[i];
          immersionDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const safetyDetail: any = {
          'Zen': 0,
          'Very Safe': 0,
          'Safe': 0,
          'Unsafe': 0,
          'Very Unsafe': 0
        };

        const safetyBreakup: [] = item.safety_breakup ? item.safety_breakup : [];
        for (let i = 0; i < safetyBreakup.length; i++) {
          const item: any = safetyBreakup[i];
          safetyDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const objectData: any = {
          session_id: item.session_id,
          project_id: item.project_id,
          braintrust_id: item.braintrust_id,
          participants: item.participantscount,
          name: item.session_title,
          immersion: Number(item.immersion_index),
          safety: Number(item.safety_index),
          immersion_color_indicator: item.immersion_color_indicator,
          safety_color_indicator: item.safety_color_indicator,
          start: item.started_at ? item.started_at : item.scheduled_start_at,
          end: item.ended_at ? item.ended_at : item.scheduled_end_at,
          status: item.session_status,
          session_code: item.session_code,
          session_category: item.session_category,
          session_subcategory: item.session_subcategory,
          clips: clips,
          immersion_detail: immersionDetail,
          safety_detail: safetyDetail,
          img: item.small_thumbnail ? item.small_thumbnail : '/assets/images/video-processing.png',
          img_large: item.large_thumbnail ? item.large_thumbnail : '/assets/images/video-processing.png',
          stimulus_type: item.stimulus_type,
          stimulus_status: item.stimulus_status,
          project_folders: item.project_folders,
          user: item.user,
          userColor:"hsl(" + Math.random() * 360 + ", 100%, 75%)",
          session_trim_from: item.session_trim_from,
          session_type:item.session_type,
          session_length: item.session_length,
          saved_benchmark: item.saved_benchmark,
          show_banner: item.show_banner
        };
        const index = newItems.findIndex((x:any) => x.session_code === item.session_code);
        newItems[index] = objectData;
        return objectData
      })

      return updateObject(state, {
        sessions: newItems,
      });  

    case actionTypes.GET_PROJECT_EXPERIENCE:

      const { projectitems } = action.payload;
      let addProjectExperience: any =  [];

      if(projectitems){

        addProjectExperience = projectitems.firstpage ? [] : state.projectSessions;

        //filter deleted Expetience from list
        if(!!localStorage.getItem("deleteExpId")){
          const delId = Number(localStorage.getItem("deleteExpId"));
          const tobedeleteproject = addProjectExperience.filter((x:any) => x.session_id === delId);
        
          if(tobedeleteproject && tobedeleteproject.length){
            addProjectExperience = addProjectExperience.filter((x:any) => x.session_id !== delId);
            localStorage.removeItem("deleteExpId");
          } 
        }

        projectitems.sessions && projectitems.sessions.length && projectitems.sessions.map((item: any) => {
          const clips = []
          const totalClips = item.stimulus_clips ? item.stimulus_clips : []
          for (let i = 0; i < totalClips.length; i++) {

            const mod_length = UtilService.convertSecondsToHHMMSS(Number(totalClips[i].end_clip) - Number(totalClips[i].start_clip));
            const mod_start = Number(totalClips[i].start_clip);
            const mod_end = Number(totalClips[i].end_clip);

            const async_length = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip) - UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
            const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
            const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip));

            clips.push({
              // session_id: 'clip-' + uuidv4(),
              session_id: 'clip-' + totalClips[i].clip_id,
              session_code: item.session_code,
              session_type: item.session_type,
              session_title: item.session_title,
              session_status: item.session_status,
              img: '/assets/images/video-processing.png',
              name: totalClips[i].title ? totalClips[i].title : '-',
              immersion: totalClips[i].immersion_index ? Number(totalClips[i].immersion_index) : '-',
              safety: totalClips[i].safety_index ? Number(totalClips[i].safety_index) : '-',
              length: item.session_type === 'ASYNC' ? async_length : mod_length,
              start: item.session_type === 'ASYNC' ? async_start : mod_start,
              end: item.session_type === 'ASYNC' ? async_end : mod_end,
              safety_tier_indicator: totalClips[i].safety_tier_indicator,
              safety_color_indicator: totalClips[i].safety_color_indicator,
              safety_context_indicator: totalClips[i].safety_context_indicator,
              immersion_color_indicator: totalClips[i].immersion_color_indicator,
              immersion_context_indicator: totalClips[i].immersion_context_indicator,
              immersion_tier_indicator: totalClips[i].immersion_tier_indicator,
              clip_id: totalClips[i].clip_id
            })
          }

          const immersionDetail: any = {
            'Captivated': 0,
            'Absorbed': 0,
            'Interested': 0,
            'Indifferent': 0,
            'Tuned Out': 0
          };

          const immersionBreakup: [] = item.immersion_breakup ? item.immersion_breakup : [];
          for (let i = 0; i < immersionBreakup.length; i++) {
            const item: any = immersionBreakup[i];
            immersionDetail[item['context_indicator']] = Number(item['category_percent']);
          }

          const safetyDetail: any = {
            'Zen': 0,
            'Very Safe': 0,
            'Safe': 0,
            'Unsafe': 0,
            'Very Unsafe': 0
          };

          const safetyBreakup: [] = item.safety_breakup ? item.safety_breakup : [];
          for (let i = 0; i < safetyBreakup.length; i++) {
            const item: any = safetyBreakup[i];
            safetyDetail[item['context_indicator']] = Number(item['category_percent']);
          }
          
          const objectData: any = {
            session_id: item.session_id,
            project_id: item.project_id,
            participants: item.participantscount,
            name: item.session_title,
            immersion: Number(item.immersion_index),
            safety: Number(item.safety_index),
            immersion_color_indicator: item.immersion_color_indicator,
            safety_color_indicator: item.safety_color_indicator,
            start: item.started_at ? item.started_at : item.scheduled_start_at,
            end: item.ended_at ? item.ended_at : item.scheduled_end_at,
            session_category: item.session_category,
            session_subcategory: item.session_subcategory,
            status: item.session_status,
            session_code: item.session_code,
            session_type: item.session_type,
            clips: clips,
            immersion_detail: immersionDetail,
            safety_detail: safetyDetail,
            img: item.small_thumbnail ? item.small_thumbnail : '/assets/images/video-processing.png',
            img_large: item.large_thumbnail ? item.large_thumbnail : '/assets/images/video-processing.png',
            stimulus_type: item.stimulus_type,
            stimulus_status: item.stimulus_status,
            project_folders: item.project_folders,
            user: item.user,
            userColor:"hsl(" + Math.random() * 360 + ", 100%, 75%)",
            session_trim_from: item.session_trim_from,
            session_length: item.session_length,
            saved_benchmark: item.saved_benchmark,
            show_banner: item.show_banner
          };
          addProjectExperience.push(objectData);

          return objectData
        });
  

        return updateObject(state, {
          projectSessions: addProjectExperience,
          // experience: projectitems,
          is_loaded: true,
          listLoading: false,
          // totalExperience: projectitems.count ? projectitems.count : 0,
          // userColumn : projectitems.show_user_column
        });
      }

      return updateObject(state, {
        projectSessions: addProjectExperience ? addProjectExperience : [],
        // experience: projectitems,
        is_loaded: true,
        listLoading: false,
        // totalExperience: projectitems.count ? projectitems.count : 0,
        // userColumn : projectitems.show_user_column
      });
    
    case actionTypes.GET_LIST_EXPERIENCE_REELS_SUCCESS:
    
      const { reelsitems } = action.payload;
      let addReelsExperience: any = reelsitems.firstpage ? [] : [...state.reels];
      
      //filter deleted Expetience from list
      if(!!localStorage.getItem("deleteExpId")){
        const delId = Number(localStorage.getItem("deleteExpId")) 
        const tobedeletereel = addReelsExperience.filter((x:any) => x.session_id === delId);
        
        if(tobedeletereel && tobedeletereel.length){
          addReelsExperience = addReelsExperience.filter((x:any) => x.session_id !== delId);
          localStorage.removeItem("deleteExpId");
        }
      }
      reelsitems.sessions && reelsitems.sessions.length && reelsitems.sessions.map((item: any) => {
        
        const clips: any[] = [];
        
        const immersionDetail: any = {
          'Captivated': 0,
          'Absorbed': 0,
          'Interested': 0,
          'Indifferent': 0,
          'Tuned Out': 0
        };

        const immersionBreakup: [] = item.immersion_breakup ? item.immersion_breakup : [];
        for (let i = 0; i < immersionBreakup.length; i++) {
          const item: any = immersionBreakup[i];
          immersionDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const safetyDetail: any = {
          'Zen': 0,
          'Very Safe': 0,
          'Safe': 0,
          'Unsafe': 0,
          'Very Unsafe': 0
        };

        const safetyBreakup: [] = item.safety_breakup ? item.safety_breakup : [];
        for (let i = 0; i < safetyBreakup.length; i++) {
          const item: any = safetyBreakup[i];
          safetyDetail[item['context_indicator']] = Number(item['category_percent']);
        }

        const objectData: any = {
          session_id: item.session_id,
          project_id: item.project_id,
          participants: item.participantscount,
          name: item.session_title,
          immersion: Number(item.immersion_index),
          safety: Number(item.safety_index),
          immersion_color_indicator: item.immersion_color_indicator,
          safety_color_indicator: item.safety_color_indicator,
          start: item.started_at ? item.started_at : item.scheduled_start_at,
          end: item.ended_at ? item.ended_at : item.scheduled_end_at,
          created_at: item.created_at ? item.created_at : "",
          status: item.session_status,
          session_code: item.session_code,
          clips: clips,
          reel_sessions: item.reel_sessions ? item.reel_sessions : [],
          immersion_detail: immersionDetail,
          safety_detail: safetyDetail,
          img: item.small_thumbnail ? item.small_thumbnail : '/assets/images/video-processing.png',
          img_large: item.large_thumbnail ? item.large_thumbnail : '/assets/images/video-processing.png',
          stimulus_type: item.stimulus_type,
          stimulus_status: item.stimulus_status,
          project_folders: item.project_folders,
          user: item.user,
          userColor: "hsl(" + Math.random() * 360 + ", 100%, 75%)",
          session_trim_from: item.session_trim_from,
          session_type: item.session_type,
          survey_link: item.survey_link,
          saved_benchmark: item.saved_benchmark,
          show_banner: item.show_banner
        };
        
        if (!addReelsExperience.find((val: any) => val.session_id === item.session_id)) {
          addReelsExperience.push(objectData)
        } else {
          let index: any = ''
          for (let j = 0; j < addReelsExperience.length; j++) {
            if (addReelsExperience[j].session_id === item.session_id) {
              index = j
            }
          }
          if (index !== '') {
            addReelsExperience[index] = objectData
          }
        }
        return objectData
      })

      return updateObject(state, {
        reels: addReelsExperience,
        reelexperience: reelsitems,
        is_loaded: true,
        listLoading: false,
        totalReelExperience: reelsitems.count ? reelsitems.count : 0,
        // userColumn : reelsitems.show_user_column
      });

      
    case actionTypes.REELS_SESSIONS_LIST_SUCCESS:
      return updateObject(state, {
        reel_sessions: action.payload,
        is_loading: false,
      });
      
    case actionTypes.GET_ONLY_REELS_SESSIONS_SUCCESS:
      return updateObject(state, {
        onlyReelSessions: action.payload,
        is_loading: false,
      });
    
    
    case actionTypes.UPDATE_SEARCH_SESSION_PAGE:
      return updateObject(state, {
        searchSessionPage: action.payload
      });
    
    case actionTypes.UPDATE_SEARCH_CLIP_PAGE:
      return updateObject(state, {
        searchClipPage: action.payload
      });

    case actionTypes.UPDATE_PAGE:
      return updateObject(state, {
        page: action.payload
      });
    case actionTypes.UPDATE_REELS_PAGE:
      return updateObject(state, {
        reels_page: action.payload
      });
    //Dashboard sorting var
    case actionTypes.SORT_COLUMN_FILTER_VALUE:
      return updateObject(state,{
        sort_column_value:action.payload.sort_column,
        sort_direction :action.payload.sort_direction,
        filter_name:action.payload.filter_name,
        filter_direction:action.payload.filter_direction,
      })
    //Project Sorting Var
    case actionTypes.SORT_PROJECT_COLUMN_FILTER_VALUE:
      return updateObject(state,{
        sort_column_value_project:action.payload.sort_column_project,
        sort_direction_project :action.payload.sort_direction_project,
        filter_name_project:action.payload.filter_name_project,
        filter_direction_project:action.payload.filter_direction_project,
      })
    // Reels sorting var  
    case actionTypes.SORT_REELS_COLUMN_FILTER_VALUE:
      return updateObject(state,{
        reels_filter_direction: action.payload.reels_filter_direction,
        reels_filter : action.payload.reels_filter,
        reels_sort_column : action.payload.reels_sort_column, 
        reels_sort_direction:action.payload.reels_sort_direction 
      })
    case actionTypes.EXPERIENCE_EDIT_SUCCESS:
    case actionTypes.EXPERIENCE_COMPLETE_SUCCESS:
    case actionTypes.EXPERIENCE_CANCEL_SUCCESS:
    case actionTypes.EXPERIENCE_SAVE_SINGLE:

      return updateObject(state, {
        single: action.payload,
        is_loaded: true,
      });

    case actionTypes.EXPERIENCE_ADD_SUCCESS:
      return updateObject(state, {
        single: action.payload,
        is_loading: false,
      });

    case actionTypes.REELS_ADD_SUCCESS:
      return updateObject(state, {
        reeladd: action.payload,
        is_loading: false,
      });

    case actionTypes.SET_EXPERIENCE_LOADING:
      return updateObject(state, {
        is_loading: action.payload,
      });

    case actionTypes.SET_BENCHMARK_LOADING:
      return updateObject(state, {
        benchmarkLoading: action.payload,
      });
    
    case actionTypes.SET_EXPERIENCE_SEARCH_LOADING:
      return updateObject(state, {
        is_search_loading: action.payload,
      });

    case actionTypes.EXPERIENCE_EMPTY:

      return updateObject(state, {
        single: null,
        is_loading: false,
      });

    case actionTypes.UPDATE_STIMULUS:

      return updateObject(state, {
        stimulus: action.payload
      });

    case actionTypes.UPDATE_MERGE_BUTTON_STATUS:

      return updateObject(state, {
        showMergeButton: action.payload
      });
      
    case actionTypes.UPDATE_SEARCHFILTERS:
      return updateObject(state, {
        searchfilters: action.payload
      });

    case actionTypes.UPDATE_SEARCHTEXT:
      return updateObject(state, {
        searchText: action.payload
      });

    case actionTypes.CLEAR_SEARCH:
      return updateObject(state, {
        searchCleared: action.payload
      });
    
    case actionTypes.UPDATE_SEARCHUSERS:
      return updateObject(state, {
        searchUsers: action.payload
      });

    case actionTypes.GET_CRETOR_LIST:

      return updateObject(state, {
        creatorList: action.payload
      });
      
    case actionTypes.GET_SESSION_PARTICIPANT:
      const payload = action.payload;
      if (payload) {
        const clips = [];
        const { session } = payload;
        const totalClips = session.stimulusclips ? session.stimulusclips : [];
        for (let i = 0; i < totalClips.length; i++) {

          const mod_length = UtilService.convertSecondsToHHMMSS(Number(totalClips[i].end_clip) - Number(totalClips[i].start_clip));
          const mod_start = Number(totalClips[i].start_clip);
          const mod_end = Number(totalClips[i].end_clip);

          const async_length = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip) - UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_start = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].start_clip));
          const async_end = UtilService.convertSecondsToHHMMSS(UtilService.getSecondsFromHHMMSS(totalClips[i].end_clip));

          clips.push({
            // session_id: 'clip-' + uuidv4(),
            session_id: 'clip-' + totalClips[i].clip_id,
            session_code: session.session_code,
            session_type: session.session_type,
            session_title: session.session_title,
            session_status: session.session_status,
            img: '/assets/images/video-processing.png',
            name: totalClips[i].title ? totalClips[i].title : '-',
            immersion: totalClips[i].immersion_index ? Number(totalClips[i].immersion_index) : '-',
            safety: totalClips[i].safety_index ? Number(totalClips[i].safety_index) : '-',
            length: session.session_type === 'ASYNC' ? async_length : mod_length,
            start: session.session_type === 'ASYNC' ? async_start : mod_start,
            end: session.session_type === 'ASYNC' ? async_end : mod_end,
            safety_tier_indicator: totalClips[i].safety_tier_indicator,
            safety_color_indicator: totalClips[i].safety_color_indicator,
            safety_context_indicator: totalClips[i].safety_context_indicator,
            immersion_color_indicator: totalClips[i].immersion_color_indicator,
            immersion_context_indicator: totalClips[i].immersion_context_indicator,
            immersion_tier_indicator: totalClips[i].immersion_tier_indicator,
            clip_id: totalClips[i].clip_id
          })
        }
        session['stimulusclips'] = clips;
      }
      return updateObject(state, {
        participants: payload,
        is_loading: action && action.payload && action.payload.isloading ? true : false,
      });

    case actionTypes.EXPERIENCES_RELOAD:

      return updateObject(state, {
        is_loaded: false,
      });

    case actionTypes.UPDATE_TOTAL_EXPERIENCE_COUNT:
      return updateObject(state, {
        totalExperienceCount: action.payload,
        is_loading: false,
      });

    case actionTypes.BRAINTRUST_LIST:
      return updateObject(state, {
        braintrustList: action.payload,
      });    

    case actionTypes.UPDATE_SEARCHKEY:
      return updateObject(state, {
        searchKey: action.payload
      });

    case actionTypes.SET_SEARCH_TEXT:
      return updateObject(state, {
        searchnewText: action.payload
      });

    case actionTypes.SET_CHECKED:
      return updateObject(state, {
        checked: action.payload
      });

    case actionTypes.SET_SELECTED:
      return updateObject(state, {
        selected: action.payload
      });

    case actionTypes.SET_USER_DROPDOWN:
      return updateObject(state, {
        isUserDropdown: action.payload
      });

    case actionTypes.DELETE_CLIP_SUCCESS:
      return updateObject(state, {
        sessions: ({
          clips:{
            ...state.sessions.map((val:any)=>{
              if(action.payload.session_code === val.session_code){
                val.clips && val.clips.map((clip:any, key:number)=>{
                  if(action.payload.clid_id === clip.clip_id){
                    val.clips.splice(key, 1);
                  }
                });
              }
              return val;
            }),
          },
          ...state.sessions,
        }),
        projectSessions: ({
          clips:{
            ...state.projectSessions.map((projectval:any)=>{
              if(action.payload.session_code === projectval.session_code){
                projectval.clips && projectval.clips.map((clip:any, key:number)=>{
                  if(action.payload.clid_id === clip.clip_id){
                    projectval.clips.splice(key, 1);
                  }
                });
              }
              return projectval;
            }),
          },
          ...state.projectSessions,
        }),
        searchKey: {
          sessions:{...state.searchKey.sessions},
          ...state.searchKey,
        }
      });
      
    case actionTypes.DELETE_SEARCH_CLIP_SUCCESS:
      return updateObject(state, {
        searchKey: {
          sessions:{
            stimulus_clips:{
              ...state.searchKey.sessions.map((stclipval:any)=>{
                if(action.payload.session_code === stclipval.session_code){
                  stclipval.stimulus_clips && stclipval.stimulus_clips.map((clip:any, key:number)=>{
                    if(action.payload.clid_id === clip.clip_id){
                      stclipval.stimulus_clips.splice(key, 1);
                    }
                  });
                }
                return stclipval;
              }),
            },
            ...state.searchKey.sessions,
          },
          clips:{
            stimulus_clips:{
              ...state.searchKey.clips.map((stclipval:any)=>{
                if(action.payload.session_code === stclipval.session_code){
                  stclipval.stimulus_clips && stclipval.stimulus_clips.map((clip:any, key:number)=>{
                    if(action.payload.clid_id === clip.clip_id){
                      stclipval.stimulus_clips.splice(key, 1);
                    }
                  });
                }
                return stclipval;
              }),
            },
            ...state.searchKey.clips,
          },
          ...state.searchKey,
        },
      });
      
    case actionTypes.DELETE_EXPERIENCE_FROM_SESSION:
      return updateObject(state, {
        // sessions: state.sessions.filter((val: any) => !action.payload.includes(val.session_code)),
        sessions: {
          ...state.sessions.map((val: any, key:number) => {
            if((action.payload.indexOf(val.session_code)) !== -1){  
              state.sessions.splice(key, 1);
            }
            return val;
          }),
          ...state.sessions
        },
        projectSessions: {
          ...state.projectSessions.map((projval: any, key:number) => {
            if((action.payload.indexOf(projval.session_code)) !== -1){  
              state.projectSessions.splice(key, 1);
            }
            return projval;
          }),
          ...state.projectSessions
        },
        reels: {
          ...state.reels.map((reelval: any, key:number) => {
            if((action.payload.indexOf(reelval.session_code)) !== -1){  
              state.reels.splice(key, 1);
            }
            return reelval;
          }),
          ...state.reels
        },
        searchKey: {
          sessions:{
            ...state.searchKey.sessions.map((searchkeyval:any, key:number)=>{
              if(action.payload.indexOf(searchkeyval.session_code) !== -1){
                state.searchKey.sessions.splice(key, 1);
              }
              return searchkeyval;
            })
          },
          ...state.searchKey,
        }
      });

    case actionTypes.REBNAME_EXPERIENCE_FROM_SESSION:
      
      return updateObject(state, {
        sessions: state.sessions.map((val: any) => {
          if(Number(action.payload.session_id) === val.session_id){
            val.name = action.payload.session_title;
          }
          return val;
        }),
        projectSessions: state.projectSessions.map((projval: any) => {
          if(Number(action.payload.session_id) === projval.session_id){
            projval.name = action.payload.session_title;
          }
          return projval;
        }),
        reels: state.reels.map((reelval: any) => {
          if(Number(action.payload.session_id) === reelval.session_id){
            reelval.name = action.payload.session_title;
          }
          return reelval;
        }),
        searchKey: {
          sessions:{
            ...state.searchKey.sessions.map((searchkeyval:any)=>{
              if(Number(action.payload.session_id) === searchkeyval.session_id){
                searchkeyval.session_title = action.payload.session_title;
              }
              return searchkeyval;
            })
          },
          ...state.searchKey,
        }
      });

    case actionTypes.ADD_REMOVE_BENCHMARK_SUCCESS:
      const { session_id, saved_benchmark } = action.payload;
      return updateObject(state, {
        sessions: state.sessions.map((val: any) => {
          if (Number(session_id) === val.session_id) {
            val.saved_benchmark = saved_benchmark;
            val.show_banner = !saved_benchmark;
          }
          return val;
        }),
        projectSessions: state.projectSessions.map((projval: any) => {
          if (Number(session_id) === projval.session_id) {
            projval.saved_benchmark = saved_benchmark;
            projval.show_banner = !saved_benchmark;
          }
          return projval;
        }),
        reels: state.reels.map((reelval: any) => {
          if (Number(session_id) === reelval.session_id) {
            reelval.saved_benchmark = saved_benchmark;
            reelval.show_banner = !saved_benchmark;
          }
          return reelval;
        }),
        searchKey: {
          sessions: {
            ...state.searchKey.sessions.map((searchkeyval:any) => {
              if (Number(session_id) === searchkeyval.session_id) {
                searchkeyval.saved_benchmark = saved_benchmark;
                searchkeyval.show_banner = !saved_benchmark;
              }
              return searchkeyval;
            })
          },
          ...state.searchKey,
        },
        benchmarkLoading: false
      });

    case actionTypes.CLIP_RENAME_SUCCESS:
    
      return updateObject(state, {
        sessions: ({
          clips:{
            ...state.sessions.map((clipval:any)=>{
              if(action.payload.session_code === clipval.session_code){
                clipval.clips && clipval.clips.map((clip:any)=>{
                  if(action.payload.clip_id === clip.clip_id){
                    clip.name = action.payload.title;
                  }
                });
              }
              return clipval;
            }),
          },
          ...state.sessions,
        }),
        projectSessions: ({
          clips:{
            ...state.projectSessions.map((clipval:any)=>{
              if(action.payload.session_code === clipval.session_code){
                clipval.clips && clipval.clips.map((clip:any)=>{
                  if(action.payload.clip_id === clip.clip_id){
                    clip.name = action.payload.title;
                  }
                });
              }
              return clipval;
            }),
          },
          ...state.projectSessions,
        }),
        searchKey: ({
          sessions:{...state.searchKey.sessions},
          ...state.searchKey,
        }),
      });

    case actionTypes.CLIP_SEARCH_RENAME_SUCCESS:
    
      return updateObject(state, {
        sessions: state.sessions.map((renameval: any) => {
          if(action.payload.session_code === renameval.session_code){
            renameval.name = action.payload.session_title;
          }
          return renameval;
        }),

        searchKey: {
          sessions:{
            stimulus_clips:{
              ...state.searchKey.sessions.map((searchclipval:any)=>{
                if(action.payload.session_code === searchclipval.session_code){
                  searchclipval.stimulus_clips && searchclipval.stimulus_clips.map((clip:any)=>{
                    if(action.payload.clip_id === clip.clip_id){
                      clip.name = action.payload.title;
                      clip.title = action.payload.title;
                    }
                  });
                }
                return searchclipval;
              }),
            },
            ...state.searchKey.sessions,
          },
          clips:{
            stimulus_clips:{
              ...state.searchKey.clips.map((searchclipval:any)=>{

                if(action.payload.session_code === searchclipval.session_code){
                  searchclipval.stimulus_clips && searchclipval.stimulus_clips.map((clip:any)=>{
                    if(action.payload.clip_id === clip.clip_id){
                      clip.name = action.payload.title;
                      clip.title = action.payload.title;
                    }
                  });
                }
                return searchclipval;
              }),
            },
            ...state.searchKey.clips,
          },
          ...state.searchKey,
        },
      });

    case actionTypes.INITI_EXP_PARTICIPANT_DATA:
      return updateObject(state, {
        participants: null
      });
      
    default:
      return state;
  }
};

export default reducer;
